import { render, staticRenderFns } from "./ButtonsSection.vue?vue&type=template&id=3c8bb306&scoped=true&"
import script from "./ButtonsSection.vue?vue&type=script&lang=js&"
export * from "./ButtonsSection.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsSection.vue?vue&type=style&index=0&id=3c8bb306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8bb306",
  null
  
)

export default component.exports